/**
PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2026 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

/**
 * Mapped Card Header Styles styles
 *
 * @file SubscriptionStatusBtnStyles.jsx
 * @author Ujjwal Sana
 * @since 1.2.8
 */

import mixins from '../../../assets/styles/mixins.scss';

const SubscriptionStatusBtnStyles = () => ({
  container: {
    display: 'inline-flex',
    minHeight: '32px',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: 4,
    color: mixins.upgradeAccessColor,
    background: mixins.upgradeAccessBGColor,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize14,
    fontStyle: 'normal',
    fontWeight: mixins.fontWeight500,
    lineHeight: '16px',
    letterSpacing: '0.24px',
    width: 'fit-content',

    '&.subscribed': {
      color: mixins.partOfSubscriptionBGColor,
      background: mixins.accentBlueTextColor,
      flex: 'none',
      marginLeft: 8
    }
  }
});

export default SubscriptionStatusBtnStyles;

